/**
 * One-time forced sign-out on upgrade. Bump FORCED_SIGNOUT_VERSION to sign every
 * native install out once on its next launch and reset the server to the default
 * (prod in store builds). The marker is persisted, so it happens only once per bump.
 *
 * 1: the `test$` prefix now reaches TEST only for koutavasj accounts.
 */
export const FORCED_SIGNOUT_VERSION = 1;
export function resolveForcedSignout(persisted) {
    const applied = persisted.forcedSignoutVersion ?? 0;
    if (applied >= FORCED_SIGNOUT_VERSION) {
        return { signOut: false, markVersion: false };
    }
    const hasSession = !!(persisted.userToken || persisted.refreshToken);
    // Fresh installs (no session) just record the marker; nothing to sign out.
    return { signOut: hasSession, markVersion: true };
}
